<template>
  <div class="page-class page-user-list">
    <h1 class="page-title text-center">{{ title }}</h1>
    <tms-list-box
      :columns="columns"
      :rows="tmsList"
      :baseUrl="baseUrl"
      :loading="loading"
      :showAdd="false"
      :showToolbar="true"
      :showPagination="true"
      :showDownload="true"
      :showFilter="true"
      :pagination="pagination"
      :searchItems="searchItems"
      :filterOptions="filterOptions"
      downloadText="Download List"
      addText="Create new CX Pulse 360"
      emptyText="No CX Pulse 360 found. Please add new CX Pulse 360."
      @edit="onEdit"
      @download="onDownload"
    >
      <template v-slot:emailAddressFormatted="slotProps">
        <span class="span-text span-block">
          {{ slotProps.row.email }}
        </span>
        <template v-if="slotProps.row.confirmedAtFormatted">
          <span class="text-success span-help-text" :title="slotProps.row.confirmedAt">
            ({{ slotProps.row.confirmedAtFormatted }})
          </span>
        </template>
        <template v-if="slotProps.row.confirmedAtFormatted === null">
          <span class="text-warning span-help-text"> (Not confirmed) </span>
        </template>
      </template>
      <template v-slot:lastLoginAtFormatted="slotProps">
        <template v-if="slotProps.row.lastLoginAtFormatted">
          <span class="text-success">{{ slotProps.row.lastLoginAtFormatted }}</span>
        </template>
        <template v-if="slotProps.row.lastLoginAtFormatted == null">
          <span class="text-warning">Never logged in</span>
        </template>
      </template>
      <template v-slot:blockedAtFormatted="slotProps">
        <template v-if="slotProps.row.blockedAtFormatted">
          <span class="text-success">{{ slotProps.row.blockedAtFormatted }}</span>
        </template>
        <template v-if="slotProps.row.blockedAtFormatted == null">
          <span class="text-warning">Never logged in</span>
        </template>
      </template>
    </tms-list-box>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState, mapActions } from 'vuex';
import router from '@/router';
import _ from 'lodash';
import TmsListBox from '../../components/TmsListBox.vue';

export default {
  name: 'TMSList',
  components: { TmsListBox },
  metaInfo() {
    return {
      title: 'CX Pulse 360 List',
      meta: [
        {
          name: 'description',
          content: `Manage TMS List`
        }
      ]
    };
  },
  mounted() {
    this.listTMS({ query: this.getQueryWithAction() });
  },
  beforeRouteUpdate(to, from, next) {
    this.listTMS({ query: this.getQueryWithAction(to.query) });
    next();
  },
  data() {
    return {
      title: 'CX Pulse 360 List',

      columns: [
        {
          type: 'row_num',
          headerText: '#',
          class: { ' text-center': true },
          textKey: 'index',
          width: '2%'
        },
        {
          type: 'string',
          headerText: 'Customer Name',
          class: { 'text-center': true },
          textKey: 'customerName',
          width: '5%'
        },
        {
          type: 'string',
          headerText: 'Customer Mobile',
          class: { 'text-center': true },
          textKey: 'customerMobile',
          width: '5%'
        },
        {
          type: 'String',
          headerText: 'Customer Email',
          class: { 'text-center': true },
          textKey: 'customerEmail',
          width: '5%'
        },
        {
          type: 'String',
          headerText: 'Ticket Owner',
          class: { 'text-center': true },
          textKey: 'ticketOwner',
          width: '5%'
        },
        {
          type: 'String',
          headerText: 'Assigned By',
          class: { 'text-center': true },
          textKey: 'assignedBy',
          width: '5%'
        },
        {
          type: 'String',
          headerText: 'Platform Type',
          class: { 'text-center': true },
          textKey: 'platformType',
          width: '5%'
        },
        {
          type: 'String',
          headerText: 'Store Id',
          class: { 'text-center': true },
          textKey: 'storeId',
          width: '5%'
        },
        {
          type: 'String',
          headerText: 'Store Manager',
          class: { 'text-center': true },
          textKey: 'storeManager',
          width: '5%'
        },
        {
          type: 'String',
          headerText: 'Reference Number',
          class: { 'text-center': true },
          textKey: 'referenceNumber',
          width: '6%'
        },
        {
          type: 'String',
          headerText: 'Bill Date',
          class: { 'text-center': true },
          textKey: 'billDate',
          width: '6%'
        },
        {
          type: 'String',
          headerText: 'Bill Number',
          class: { 'text-center': true },
          textKey: 'billNumber',
          width: '6%'
        },
        {
          type: 'String',
          headerText: 'Attachment URL',
          class: { 'text-center': true },
          urlKey: 'attachmentURL',
          width: '6%'
        },
        // Region For Complain column commented out
        // {
        //   type: 'String',
        //   headerText: 'Region For Complain',
        //   class: { 'text-center': true },
        //   textKey: 'regionForComplain',
        //   width: '5%'
        // },
        {
          type: 'String',
          headerText: 'Store Resolution',
          class: { 'text-center': true },
          textKey: 'storeResolution',
          width: '6%'
        },
        {
          type: 'String',
          headerText: 'Time of Store Resolution by Store',
          class: { 'text-center': true },
          textKey: 'timeOfStoreResolutionByStore',
          width: '5%'
        },
        {
          type: 'String',
          headerText: 'Action',
          class: { 'text-center': true },
          textKey: 'action',
          width: '5%'
        },
        {
          type: 'String',
          headerText: 'Ticket Number',
          class: { 'text-center': true },
          textKey: 'ticketNumber',
          width: '5%'
        },
        {
          type: 'String',
          headerText: 'Convox Form Type',
          class: { 'text-center': true },
          textKey: 'convoxFormType',
          width: '4%'
        },
        {
          type: 'String',
          headerText: 'Updated At',
          class: { 'text-center': true },
          textKey: 'updatedAt',
          width: '4%'
        },
        {
          type: 'functions',
          headerText: 'Functions',
          class: { 'text-center': true },
          width: '5%',
          functions: {
            delete: false,
            edit: true
          }
        }
      ],
      searchItems: ['Store Id', 'Customer Mobile'],
      filterOptions: [
        { value: null, text: 'Select Filter' },
        { value: 'Pending', text: 'Pending' },
        { value: 'Closed', text: 'Closed' }
      ]
    };
  },
  computed: {
    ...mapState('tms', ['loading', 'baseUrl', 'tmsList', 'pagination', 'downloadList']),
    ...mapState('darkMode', ['isDarkMode'])
  },
  watch: {
    downloadList(newValue) {
      if (newValue.length > 0) {
        const allColumns = _.uniq(_.flatMap(newValue, row => Object.keys(row || {})));
        let csv = `Row Number,${allColumns.join(',')}\n`;
        newValue.forEach((row, rowIndex) => {
          const rowValues = allColumns.map(column => this.escapeCsvValue(_.get(row, column, '')));
          csv += `${rowIndex + 1},${rowValues.join(',')}\n`;
        });

        const anchor = document.createElement('a');
        anchor.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;
        anchor.target = '_blank';
        anchor.download = 'CX Pulse 360 List.csv';
        anchor.click();
      }
    },
    '$route.query.filter'(newValue) {
      this.listTMS({ query: this.getQueryWithAction() });
    }
  },
  methods: {
    ...mapActions('tms', ['listTMS', 'deleteOne', 'getOne', 'download']),
    escapeCsvValue(value) {
      if (value === null || value === undefined) {
        return '';
      }
      const stringValue = String(value);
      if (stringValue.includes('"') || stringValue.includes(',') || stringValue.includes('\n')) {
        return `"${stringValue.replace(/"/g, '""')}"`;
      }
      return stringValue;
    },
    getQueryWithAction(query = null) {
      const routeQuery = query || this.$route.query;
      const queryWithAction = { ...routeQuery };
      if (routeQuery.filter) {
        queryWithAction.action = routeQuery.filter;
        delete queryWithAction.filter;
      }
      return queryWithAction;
    },
    onAdd() {
      router.push('/cx-pulse-360/new');
    },
    onEdit({ row }) {
      router.push(`/cx-pulse-360/${row.id}`);
    },
    onDownload() {
      const downloadQuery = this.getQueryWithAction();
      this.download({ query: { ...downloadQuery, page_size: 9999, page: 1 } });
    },
    onDelete({ row }) {
      Vue.swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this.",
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        background: this.isDarkMode ? '#464d54' : '#ffffff',
        customClass: {
          title: this.isDarkMode ? 'text-light' : 'text-dark',
          content: this.isDarkMode ? 'text-light' : 'text-dark'
        },
        preConfirm: () => {
          this.deleteOne({
            id: row.id
          });
        }
      });
    }
  }
};
</script>
